import { Notification } from "@/components/admin/notification"
import { TextInput } from "@/components/admin/text-input"
import { Avatar, AvatarImage } from "@/components/ui/avatar"
import { Button } from "@/components/ui/button"
import { Form, required, useLogin, useNotify } from "ra-core"
import { useState } from "react"
import type { FieldValues, SubmitHandler } from "react-hook-form"
export const LoginPage = (props: { redirectTo?: string }) => {
  const { redirectTo } = props
  const [loading, setLoading] = useState(false)
  const login = useLogin()
  const notify = useNotify()

  const handleSubmit: SubmitHandler<FieldValues> = values => {
    setLoading(true)
    login(values, redirectTo)
      .then(() => {
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        notify(
          typeof error === "string"
            ? error
            : typeof error === "undefined" || !error.message
              ? "ra.auth.sign_in_error"
              : error.message,
          {
            type: "error",
            messageArgs: {
              _:
                typeof error === "string"
                  ? error
                  : error && error.message
                    ? error.message
                    : undefined,
            },
          }
        )
      })
  }

  return (
    <div className="min-h-screen flex">
      <div className="container relative grid flex-col items-center justify-center sm:max-w-none lg:grid-cols-2 lg:px-0">
        <div className="relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex">
          <div
            className="absolute inset-0 bg-zinc-900"
            style={{
              backgroundImage:
                "url(https://images.unsplash.com/photo-1455778977533-4a3ef39091c6?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2235)",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
          <div className="relative z-20 mt-auto">
            <blockquote className="space-y-2">
              <p className="text-lg"></p>
              <footer className="text-sm text-white">{`Förnya ©  ${new Date().getFullYear()}`}</footer>
            </blockquote>
          </div>
        </div>
        <div className="lg:p-8">
          <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[40vw] xs:w-[80vw]">
            <div className="flex flex-col space-y-2 text-center items-center my-18 ">
              <Avatar className="w-40 h-40">
                <AvatarImage src="https://galvtfsffmozysmfvnnw.supabase.co/storage/v1/object/public/images/system/logo600x600.png" />
              </Avatar>
              <h1 className="text-2xl font-semibold tracking-tight">
                Bienvenue sur Riyasol
              </h1>
            </div>
            <Form className="space-y-4" onSubmit={handleSubmit}>
              <TextInput
                label="E-mail"
                source="email"
                type="email"
                validate={required()}
              />
              <TextInput
                label="Mot de passe"
                source="password"
                type="password"
                validate={required()}
              />
              <div className="flex items-center">
                <a
                  href="/forgot-password"
                  className="ml-auto inline-block text-sm underline-offset-4 hover:underline"
                >
                  Mot de passe oublié ?
                </a>
              </div>
              <Button
                type="submit"
                className="cursor-pointer w-full my-12"
                disabled={loading}
              >
                Se connecter
              </Button>
            </Form>
          </div>
        </div>
      </div>
      <Notification />
    </div>
  )
}
